<script>
import resources from './resources'

export default {
  name: 'gadget-professional',

  mixins: [resources]
}
</script>

<template lang="pug">
  page(title="Bem-vindo(a) ao Medibook!", icon="")
    .col-xs-12.content
      .container-fluid
        .row
          //--- identification
          //--- select-dates
          statistics-agendas
          //--- next-patient
          //- Se a integração não for offline
          active-agenda(v-if="!user.settings.notify.integration.offline")
          schedulings-offline(v-if="user.settings.notify.integration.offline")
          // Removido por enquanto
          // summary-agenda
          agendas-statistics
          summary-billing(v-if="!userIsEmployee")
          abstract-speciality
</template>



// WEBPACK FOOTER //
// src/app/professional/dashboard/professional/gadget/index.vue